import React from 'react';
import TextField from '@material-ui/core/TextField';

export default function CTextField(props) {
  const { label, value, onChange } = props;

  return (
    <TextField
      id="outlined-multiline-static"
      label={label || 'Поле для ввода'}
      multiline
      variant="outlined"
      fullWidth
      value={value ? value : undefined}
      onChange={onChange}
    />
  );
}
